import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 查询规则
 * @param data
 * @returns {*}
 */
export function advancedQuery(data) {
  return request({
    url: URL.booking.ruleConfigAi.advancedQueryUrl,
    method: 'post',
    data
  })
}

/**
 * 保存规则
 * @param data
 * @returns {*}
 */
export function saveFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.saveUrl,
    method: 'post',
    data
  })
}

/**
 * 生成脚本
 * @param data
 * @returns {*}
 */
export function generateScriptFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.generateScriptUrl,
    method: 'post',
    data
  })
}

/**
 * 删除规则
 * @param data
 * @returns {*}
 */
export function deleteRuleConfigFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.deleteRuleConfigUrl,
    method: 'post',
    data
  })
}

/**
 * 查询应用规则
 * @param data
 * @returns {*}
 */
export function advancedQueryApplicationFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.advancedQueryApplicationUrl,
    method: 'post',
    data
  })
}

/**
 * 试运行
 * @param data
 * @returns {*}
 */
export function runApplicationFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.runApplicationUrl,
    method: 'post',
    data
  })
}

/**
 * 保存应用规则
 * @param data
 * @returns {*}
 */
export function saveApplicationFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.saveApplicationUrl,
    method: 'post',
    data
  })
}

/**
 * 删除应用规则
 * @param data
 * @returns {*}
 */
export function deleteApplicationFunc(data) {
  return request({
    url: URL.booking.ruleConfigAi.deleteApplicationUrl,
    method: 'post',
    data
  })
}

